import { Link } from 'react-router-dom';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/cd01ee5b12e74fec53d91305706c728b.jpeg"
            alt="虹橋株式会社"
            className={`h-10 w-auto object-contain transition-all duration-300 ${
              isScrolled ? '' : 'brightness-0 invert'
            }`}
          />
        </Link>

        <div className="flex items-center space-x-8">
          <a
            href="#about"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            企業情報
          </a>
          <a
            href="#services"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            サービス
          </a>
          <Link
            to="/dormitory"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            宿舎管理
          </Link>
          <a
            href="#testimonials"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            お客様の声
          </a>
          <Link
            to="/downloads"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            資料ダウンロード
          </Link>
          <a
            href="#contact"
            className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}
          >
            お問い合わせ
          </a>
        </div>
      </div>
    </nav>
  );
}
